<template>
    <div class="container">
        <div class="row">
            <div class="col col-4">
                <h2 class="h h--2 h--dark">Twój profil</h2>
                <p class="paragraph">Profil zapewnia dostęp do informacji podanych w trakcie rejestracji, a także prezentuje wszystkie efekty Twoich działań. Możesz stąd również administrować fakturami, złotówkami i punktami. </p>
                <p class="paragraph">
                    <router-link :to="{name: 'ChangePassword'}"  class="">Zmień hasło &raquo;</router-link>
                </p>
                <p class="paragraph">
                    <router-link :to="{name: 'PointsHistory'}"  class="">Historia punktów &raquo;</router-link>
                </p>
            </div>
            <div class="col col-8">
                <div class="row profile">
                    <div class="col col-12">
                        <h3 class="profile__name">{{ (user) ? user.first_name : '' }} {{ user.last_name }}</h3>
                        <p>Adres: {{ user.address.address }}, {{ user.address.postal_code }} {{ user.address.city }}</p>
                        <p>E-mail: {{ user.email }}</p>
                        <p>Telefon: {{ user.phone }}</p>
                        <p>Firma: {{ user.company }}</p>
                        <p>Zarejestrowano: {{ user.created_at }}</p>
                        <p v-if="user.group">Grupa regionalna Geberit: {{ user.group.name }}</p>
                        <p v-if="user.guardian">Opiekun: {{ user.guardian.first_name }} {{ user.guardian.last_name }} (<a :href="'mailto:' + user.guardian.email">{{ user.guardian.email }}</a>)</p>

                        <p v-if="user.is_certyficated">Certyfikat: Tak </p>
                        <p v-else-if="user.user_type_id != 5">Certyfikat: Nie </p>
                        <p v-if="user.is_certyficated">
                            Certyfikat ważny do: {{moment(user.active_certyficates[0].expire_at).format('DD.MM.YYYY')}}
                        </p>

                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ProfileComponent',
  computed: {
    user() {
      return this.$store.state.user
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/user/ProfileComponent.vue